"use strict";

$(document).ready(function () {
	$('.sitesearch-banner__form').on('submit', function (event) {
		event.preventDefault();

		const val = $(this).find('#sitesearchBannerSearchField').val();
		if (val.length > 0) {
			const loc = `${this.action}#?cludoquery=${val}`;
			window.location.href = loc;
		}
	})
})

$(window).on("resize", resizeCludoBannerImage);

function resizeCludoBannerImage() {
	let cludoBanner = document.querySelector(".cludo-banner");

	if (cludoBanner && (cludoBanner.getElementsByTagName("img").length > 0)) {
		let cludoBannerImage = cludoBanner.getElementsByTagName("img")[0];
		if (window.matchMedia("(min-width: 640px)").matches) {
			(cludoBannerImage.offsetLeft < 100) ? (cludoBannerImage.style.marginRight = "24px") : (cludoBannerImage.style.marginLeft = "24px");
		} else {
			(cludoBannerImage.offsetLeft < 100) ? (cludoBannerImage.style.marginRight = "0px") : (cludoBannerImage.style.marginLeft = "0px");
		}
	}
}
